import axios from "axios";

export default {
  getHomeConferences(context) {
    return new Promise((resolve, reject) => {
      axios.get("/conferences/home-conferences").then((response) => {
        context.commit("setHomeConferences", response.data.results);
        resolve(response.data.results);
      });
    });
  },
  getBanners(context) {
    return new Promise((resolve, reject) => {
      axios
        .get("/conferences/banners")
        .then((response) => {
          context.commit("setBanners", response.data.results);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getConferenceContent(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/conferences/reference-collencions?conference_id=${id}&limit=100`)
        .then((response) => {
          let content = response.data.results;
          content.sort((a, b) => {
            return a.order - b.order;
          });
          context.commit("setConferenceContent", content);
          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getLesson(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/conferences/lesson/${id}`)
        .then((response) => {
          context.commit("setLesson", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getLessons(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/conferences/lessons?conference_id=${id}&limit=100`)
        .then((response) => {
          context.commit("setLessons", response.data.results);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  setProgress(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/conferences/progress", data)
        .then(resolve)
        .catch(reject);
    });
  },

  getCollections(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/conferences/collections?conference=${id}`)
        .then((response) => {
          context.commit("setCollections", response.data.results);
          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getConferences(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/conferences/`)
        .then((response) => {
          let filteredConferences = response.data.results.filter(
            (conference) => conference.category.id === id
          );
          if (filteredConferences.length) {
            context.commit("setConferences", filteredConferences);
            resolve(filteredConferences);
          } else {
            resolve([]);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAll(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/conferences/?limit=9999`)
        .then((response) => {
          context.commit("setAllConferences", response.data.results);
          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getConference(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/conferences/conference/${id}`)
        .then((response) => {
          context.commit("setConference", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getConferencesByType(context, { conference_type, id }) {
    return new Promise((resolve, reject) => {
      axios
        .get("/conferences/")
        .then((response) => {
          let conferencesFiltered = response.data.results.filter(
            (conference) => conference.conference_type == conference_type
          );

          context.commit(
            "setConferencesRelated",
            conferencesFiltered.filter((conference) => conference.id != id)
          );
          resolve(conferencesFiltered);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCategories(context) {
    return new Promise((resolve, reject) => {
      axios
        .get("/conferences/categories?limit=100")
        .then((response) => {
          context.commit("setCategories", response.data.results);
          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getOldCategories(context, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/conferences/lessons`)
        .then((response) => {
          const lessons = response.data.results.filter(
            (lesson) => lesson.conference.id == id
          );
          let categories = [];

          lessons.map((lesson) => {
            if (
              !categories?.find((category) => category.id == lesson.category.id)
            ) {
              categories.push({
                id: lesson.category.id,
                name: lesson.category.name,
                items: [lesson],
              });
            } else {
              categories
                .find((category) => category.id == lesson.category.id)
                .items.push(lesson);
            }
          });

          context.commit("setCategories", categories);
          resolve(response.data.results);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  addToMyList(context, conference_id) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/conferences/mylist/create", {
          conference_id,
        })
        .then(function (response) {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  removeToMyList(context, { user_id, id }) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/conferences/${user_id}/mylist/${id}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getMyList(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/conferences/mylist")
        .then(function (response) {
          context.commit("setMyList", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
};
